/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelOrderSummary64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelOrderSummary64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15Z"
            fill="currentColor"
          />
          <g>
            <path
              d="M26 36C26.5523 36 27 36.4477 27 37C27 37.5523 26.5523 38 26 38C25.4477 38 25 37.5523 25 37C25 36.4477 25.4477 36 26 36Z"
              fill="currentColor"
            />
            <path d="M39 37.5H29V36.5H39V37.5Z" fill="currentColor" />
            <path
              d="M26 31C26.5523 31 27 31.4477 27 32C27 32.5523 26.5523 33 26 33C25.4477 33 25 32.5523 25 32C25 31.4477 25.4477 31 26 31Z"
              fill="currentColor"
            />
            <path d="M39 32.5H29V31.5H39V32.5Z" fill="currentColor" />
            <path
              d="M26 26C26.5523 26 27 26.4477 27 27C27 27.5523 26.5523 28 26 28C25.4477 28 25 27.5523 25 27C25 26.4477 25.4477 26 26 26Z"
              fill="currentColor"
            />
            <path d="M39 27.5H29V26.5H39V27.5Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M49 12C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15C12 13.3431 13.3431 12 15 12H49ZM15 13C13.8954 13 13 13.8954 13 15V49C13 50.1046 13.8954 51 15 51H49C50.1046 51 51 50.1046 51 49V15C51 13.8954 50.1046 13 49 13H15Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelOrderSummary64Icon.tags = ['add', 'order', 'summary', 'cart', 'plus'];

AddPanelOrderSummary64Icon.category = '64x64 (Add panel)';

AddPanelOrderSummary64Icon.iconSize = 64;
